/*
 * @Description: file content
 */
// 计算两个时间之间的时间差 多少天时分秒
import dayjs from 'dayjs'

export const is7More = time => dayjs(time).diff(dayjs(), 'minute') > 7 * 24 * 60

export const offsetTime = time => {
  let now = dayjs()
  if (dayjs(now).isBefore(time)) {
    let days = dayjs(time).diff(now, 'days')
    let hours = dayjs(time).diff(now, 'hours') - days * 24
    let min = dayjs(time).diff(now, 'minute') - days * 24 * 60 - hours * 60
    console.log('daysdas', days, hours, min)
    // let second = dayjs(time).diff(now, 'second') - days * 24 * 60 * 60 - hours * 60 * 60 - min * 60
    return days || hours || min ? `${days}天 ${hours}小时 ${min}分钟` : ''
  } else {
    return ''
  }
}
